module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112321-Pathfinder-Established.5f6696c7.jpeg";